<div class="version-screen">
	<div class="version-center">
		<img src="assets/images/logo-tellco.png" class="splash-screen-image responsive" />
		<div class="version-width version-font center">v{{ appVersion }}</div>
		<div class="version-width center">
			<nc-button [id]="'back'" [onClick]="onBack" label="close"></nc-button>
		</div>
	</div>
</div>
